import React from "react";
import routes from "router/routes";
import OnRoute from "components/utils/OnRoute";
import { HashRouter as Router, Route, Routes } from "react-router-dom";

function App() {  
  return (
    <Router>
      <OnRoute />
      <Routes>
        {Array.from(routes).map(([key, value]) => (
          <Route
            key={key}
            path={key}
            element={<value.element breadcrumbs={value.breadcrumbs} />}
          />
        ))}
      </Routes>
    </Router>
  );
}

export default App;
